import { render, staticRenderFns } from "./PasswordPromptUpdateComponent.vue?vue&type=template&id=0710ca62&"
import script from "./PasswordPromptUpdateComponent.vue?vue&type=script&lang=js&"
export * from "./PasswordPromptUpdateComponent.vue?vue&type=script&lang=js&"
import style0 from "./PasswordPromptUpdateComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports